import { render } from "./NewsEditorView.vue?vue&type=template&id=0e90a235&scoped=true"
import script from "./NewsEditorView.vue?vue&type=script&lang=js"
export * from "./NewsEditorView.vue?vue&type=script&lang=js"

import "./NewsEditorView.vue?vue&type=style&index=0&id=0e90a235&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e90a235"]])

export default __exports__